// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"355b6b74","345":"3c1a5ad6","729":"12bf43f6"}[chunkId] + ".chunk.js";
};